// Footer.jsx
import React from "react";
import { Quote } from "lucide-react";

const Footer = () => {
  return (
    <footer className="relative mt-20 bg-white dark:bg-gray-900 text-gray-700 dark:text-gray-300 transition-colors duration-300 overflow-hidden select-none">

      {/* Subtle Quote Icon Behind Text */}
      <Quote
        size={66}
        className="absolute top-[37%] left-1/2 -translate-x-1/2 -translate-y-1/2 
        opacity-[0.065] dark:opacity-[0.05] text-gray-700 dark:text-gray-300"
      />

      {/* Quote Section */}
      <div className="max-w-5xl mx-auto px-6 py-14 flex flex-col items-center text-center space-y-3 relative z-10">
        <p className="text-[0.96rem] sm:text-[1.07rem] max-w-xl leading-[1.7] italic font-medium tracking-[0.2px] opacity-95">
          “Clean code is simple, elegant, and intentional — like a great piece of engineering.”
          <span className="block mt-1 not-italic text-[0.72rem] font-normal tracking-tight opacity-60">
            — *Robert C. Martin, Clean Code*
          </span>
        </p>
      </div>

      {/* Footer Bottom Info */}
      <div className="border-t border-gray-200 dark:border-gray-700 py-4 text-center text-[0.70rem] tracking-wide text-gray-500 dark:text-gray-400 transition-colors duration-300">
        Designed & Engineered by Ashish Karche • © {new Date().getFullYear()}
      </div>
    </footer>
  );
};

export default Footer;
